import React from 'react';
import { Box, InfoIcon, Tooltip } from 'edenred-ui';
import { Trans } from 'react-i18next';
import { useTheme } from 'styled-components';

import { Bold, Italic } from './BenefitSettingsTooltip.styles';

type BenefitSettingsTooltipProps = {
  descriptionKey: string;
};

const BenefitSettingsTooltip = ({
  descriptionKey
}: BenefitSettingsTooltipProps) => {
  const { primaryFrontColor } = useTheme();

  return (
    <Tooltip
      arrow
      placement="top"
      componentsProps={{
        tooltip: { sx: { maxWidth: '500px' } }
      }}
      title={
        <Trans
          i18nKey={descriptionKey}
          components={{ bold: <Bold />, italic: <Italic /> }}
        />
      }
    >
      <Box pl={1} id="lounari-loading-type-info-icon">
        <InfoIcon color={primaryFrontColor} />
      </Box>
    </Tooltip>
  );
};

export { BenefitSettingsTooltip };
